import styled from "styled-components"

type Props = {
  theme: string,
}

const OutlinedButton = styled.a<Props>`
  padding: 1rem 2rem calc(1rem - 5px) 2rem;
  text-decoration: none;
  text-align: center;
  font-size: 1.3rem;
  font-weight: 500;
  margin: 0;
  color: ${props => props.theme};
  border: 2px solid ${props => props.theme};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default OutlinedButton